import { STATUS_OK } from 'constants/http';
import { LOOM_SDK_API_KEY } from 'constants/runtimeConfig';

import * as logger from '../loggerx';

const setupWithSecureKey = async config => {
  try {
    const response = await fetch('/integrations-app/sdk/create-jws');

    if (response.status !== STATUS_OK) {
      throw new Error('Fetching access token to setup recordSDK failed.');
    }

    const { setup } = await import('@loomhq/record-sdk');
    const { jws } = await response.json();

    return setup({ jws, config });
  } catch (err) {
    logger.warning(err, { message: 'recordSDK setup with secure key failed.' });

    return setupWithAppId(config);
  }
};

const setupWithAppId = async config => {
  const { setup } = await import('@loomhq/record-sdk');

  return setup({
    publicAppId: LOOM_SDK_API_KEY,
    config,
  });
};

export default class RecordSDKInitializer {
  instance: any = undefined;
  promise: any = undefined;

  constructor(config = {}) {
    this.promise = setupWithSecureKey(config);
  }

  // return type should be SDKResult | void
  async waitOnInstance(): Promise<any> {
    if (this.instance) {
      return this.instance;
    }

    const instance = await this.promise;

    this.instance = instance;

    return instance;
  }
}
